import { Factory } from "lucide-react";
import type { ProductionRun } from "../models";
import { useRunTimers } from "./useRunTimers";

export function StatusBadge({
  run,
  stopped,
}: {
  run: ProductionRun;
  stopped: boolean;
}) {
  const text = stopped
    ? "Duruşta"
    : run.status === "READY"
      ? "Hazır"
      : run.status === "ACTIVE"
        ? run.planItemKind === "ACTIVITY" ? "Etkinlik sürüyor" : "Üretimde"
        : "Tamamlandı";
  return (
    <span
      className={`production-status is-${stopped ? "stopped" : run.status.toLowerCase()}`}
    >
      {text}
    </span>
  );
}
export function LiveRunTimer({ run }: { run: ProductionRun }) {
  const timers = useRunTimers(run);
  const stopped = run.downtimes.some((item) => !item.endedAt);
  const label = stopped
    ? "DURUŞ"
    : run.status === "READY"
      ? "BEKLEME"
      : run.status === "COMPLETED"
        ? "SÜRE"
        : run.planItemKind === "ACTIVITY" ? "ETKİNLİK" : "ÜRETİM";
  const value = stopped
    ? timers.downtime
    : run.status === "READY"
      ? timers.waiting
      : timers.production;
  return (
    <span
      className={`production-line-timer is-${stopped ? "stopped" : run.status.toLowerCase()}`}
    >
      <small>{label}</small>
      <strong>{value}</strong>
    </span>
  );
}
export function TouchEmpty({ title, text, actionLabel, onAction }: { title: string; text: string; actionLabel?: string; onAction?: () => void }) {
  return (
    <div className="touch-empty">
      <Factory size={38} />
      <strong>{title}</strong>
      <span>{text}</span>
      {actionLabel && onAction ? <button type="button" onClick={onAction}>{actionLabel}</button> : null}
    </div>
  );
}
